<template>
  <div v-if="technology !== null">
    <!-- 技術 -->
    <div class="block mb-5">
      <!-- Title -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>標題</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="technology.title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 技術類別 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>技術類別</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-autocomplete
            v-model="technology.bu_technology_id"
            :items="technologies"
            placeholder="請選擇所屬技術類別"
            item-text="title"
            item-value="id"
            outlined
            dense>
          </v-autocomplete>
        </div>
      </div>
      <!-- Order -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="w-248px my-n2">
          <v-text-field
            v-model="technology.order"
            placeholder="請輸入序號"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="technology.status"></FormSwitch>
        </div>
      </div>
      <!-- 封面圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">封面圖</h4>
          <div class="h5 ink-02-medium--text">
            顯示於技術列表Overview頁面 <br />
            建議尺寸：430px * 430px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="technology.cover_photo"
            dir="Technology"></ImgUploader>
        </div>
      </div>
      <!-- Slug -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">Slug</h4>
          <div class="h5 ink-02-medium--text">
            全語系共用 <br />
            建議：英文, 僅可接受dash or underline
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="technology.slug"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 副標題(列表) -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>副標題(列表)</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="technology.detail_page_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- 內頁Banner圖 -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">內頁Banner圖 </h4>
          <div class="h5 ink-02-medium--text">
            顯示於技術內頁Banner <br />
            建議尺寸：999px * 999px <br />
            檔案大小限制：&lt; 1 MB
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <ImgUploader
            :imageUrl.sync="technology.detail_page_banner"
            dir="Technology"></ImgUploader>
        </div>
      </div>
      <!-- SEO TITLE -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">SEO Title</h4>
          <div class="h5 ink-02-medium--text"></div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="technology.seo_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
      <!-- SEO Description -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-2">SEO Description</h4>
          <div class="h5 ink-02-medium--text"></div>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-text-field
            v-model="technology.seo_description"
            outlined
            dense
          ></v-text-field>
        </div>
      </div>
    </div>
    <!-- TextEditor -->
    <editor
      v-model="technology.content"
      :height="600"
      :plugins="'link image lists'"
      :toolbar="'undo redo | link|fontsize select forecolor|image|bullist numlist|outdent indent|alignleft aligncenter alignright|bold'"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import FormSwitch from '@/components/FormSwitch.vue';
import ImgUploader from '@/components/ImgUploader.vue';
import Editor from '@/components/TinymceEditor.vue';

export default {
  components: {
    FormSwitch,
    ImgUploader,
    Editor,
  },
  data: () => ({
    status: true,
    technologies: [],
  }),
  computed: {
    ...mapState('language', ['countries']),
    ...mapState('technology', ['technology']),
  },
  async created() {
    if (this.technology.bu_technology_id !== null) {
      this.technologies = await this.getTechCates(this.technology.bu_technology_id);
    }
  },
  watch: {
    async 'technology.bu_technology_id'(newValue) {
      if (newValue !== '') {
        this.technologies = await this.getTechCates(newValue);
      } else {
        this.technologies = [];
      }
    },
  },
  methods: {
    ...mapActions('technology', ['getTechCates']),
  },
};
</script>
<style></style>
